import PageHeader from "@/modules/smsLibrary/PageHeader";
import TemplateForm from "@/modules/smsLibrary/TemplateForm";
import { TEMPLATE_TITLE_MAX, stripOptOut } from "@/modules/smsLibrary/sms";
import classes from "@/modules/smsLibrary/sms.module.scss";
import { SmsTemplate } from "@/services/discount/type";
import useCreateTemplate from "@/services/template/hooks/useCreateTemplate";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";

function AddTemplate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useCreateTemplate();
  // "Make a copy" opens this page with the source template.
  const source = (useLocation().state as { template?: SmsTemplate } | null)?.template;

  return (
    <div className={classes.page}>
      <PageHeader title={source ? "کپی قالب" : "قالب جدید"} back="/dashboard/profile/template" />
      <TemplateForm
        initialTitle={source ? `${source.title ?? ""} (کپی)`.slice(0, TEMPLATE_TITLE_MAX) : ""}
        initialText={stripOptOut(source?.text)}
        showStarters={!source}
        submitLabel="ثبت و ارسال برای بررسی"
        loading={isLoading}
        onSubmit={(values) =>
          mutate(values, {
            onSuccess() {
              notifications.show({ color: "green", message: "قالب ثبت شد و برای بررسی فرستاده شد" });
              queryClient.invalidateQueries({ queryKey: ["allSmsTemplate"] });
              navigate("/dashboard/profile/template", { replace: true });
            },
          })
        }
      />
    </div>
  );
}
export default AddTemplate;
